import { useSelector, useDispatch } from "react-redux";

// translation files
import translationEn from "constants/translation/en";
import translationFa from "constants/translation/fa";
import { setCookie } from "utils/persistor";
import { setLocale } from "redux/settings/settings.actions";

const getLocale = ({ settingsData }) => settingsData.locale;

// In this hook just pass the realted section name according to the "translation" directory in constants,
// then get your appropriate object based on the selected locale.
//? HINT: if you want to join sections together pass an array to the hook.
const useTranslation = (section) => {
  const locale = useSelector(getLocale);
  const dispatch = useDispatch();

  const getAppLocale = () => locale;
  const setAppLocale = (newLocale) => {
    dispatch(setLocale(newLocale));
    setCookie("raychat_webapp_client_locale", newLocale, 1); // expires in 1 day
  };

  const getTranslationFile = (locale) => {
    if (locale === "fa") return translationFa;
    return translationEn;
  };

  // translate function
  const t = (key) => {
    const selectedFile = getTranslationFile(locale);

    // join sections
    if (Array.isArray(section)) {
      let MergedSections = {};
      section.forEach((s) => {
        MergedSections = { ...MergedSections, ...selectedFile[s] };
      });
      return MergedSections[key];
    }

    const selectedSection = selectedFile[section];
    return selectedSection[key];
  };

  // // capitalized translation
  // const tc = (key) => {
  //   // TODO: need to implement
  //   return capitalizeFirstLetter(t(key));
  // };
  // // upper-cased translation
  // const tu = (key) => {
  //   // TODO: need to implement
  //   return t(key);
  // };
  // // custom morphed translation
  // const tm = (key, morphism) => {
  //   // TODO: need to implement
  //   return t(key);
  // };

  const getTranslation = () => ({
    t,
    // tc,
    // tu,
    // tm,
  });

  return {
    getAppLocale,
    setAppLocale,
    getTranslation,
  };
};

export default useTranslation;
